import config from "../../../helper/config";
import APIHandler from "../../../handlers/APIHandler";

export const VideoService = {
  addVideo,
  updateVideo,
  getVideosByContainerId,
  deleteVideo,
  addTopic,
  updateTopic,
  getTopicsByNodeId,
  deleteTopicBulkVideos
};

async function addVideo(data) {
  const requestOptions = {
    method: "POST",
    headers: {
      ...APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  };
  const response = await fetch(
    `${config.oat_api_url}/manage/videos/add`,
    requestOptions
  );
  return APIHandler.handleResponse(response);
}

async function updateVideo(data, video_id) {
  const requestOptions = {
    method: "PUT",
    headers: {
      ...APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  };
  const response = await fetch(
    `${config.oat_api_url}/manage/videos/update/${video_id}`,
    requestOptions
  );
  return APIHandler.handleResponse(response);
}

async function getVideosByContainerId(container_id) {
  const requestOptions = {
    method: "GET",
    headers: {
      ...APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
      "Time-Zone": Intl.DateTimeFormat().resolvedOptions().timeZone,
    },
  };
  const response = await fetch(
    `${config.oat_api_url}/manage/videos/get-by-container-id/${container_id}`,
    requestOptions
  );
  return APIHandler.handleResponse(response);
}

async function deleteVideo(document_id, topic_id) {
  const requestOptions = {
    method: "DELETE",
    headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
  };

  const response = await fetch(
    `${config.oat_api_url}/manage/videos/delete/${document_id}/${topic_id}`,
    requestOptions
  );

  return APIHandler.handleResponse(response);
}

async function addTopic(data) {
  const requestOptions = {
    method: "POST",
    headers: {
      ...APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  };
  const response = await fetch(
    `${config.oat_api_url}/manage/videos/add-topic`,
    requestOptions
  );
  return APIHandler.handleResponse(response);
}

async function updateTopic(topic_id, data) {
  const requestOptions = {
    method: "PUT",
    headers: {
      ...APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  };
  const response = await fetch(
    `${config.oat_api_url}/manage/videos/update-topic/${topic_id}`,
    requestOptions
  );
  return APIHandler.handleResponse(response);
}

async function getTopicsByNodeId(node_id) {
  const requestOptions = {
    method: "GET",
    headers: {
      ...APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
      "Time-Zone": Intl.DateTimeFormat().resolvedOptions().timeZone,
    },
  };
  const response = await fetch(
    `${config.oat_api_url}/manage/videos/get-topics-by-node/${node_id}`,
    requestOptions
  );
  return APIHandler.handleResponse(response);
}

async function deleteTopicBulkVideos(topic_id) {
  const requestOptions = {
    method: "DELETE",
    headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
  };

  const response = await fetch(
    `${config.oat_api_url}/manage/videos/delete-topic/${topic_id}`,
    requestOptions
  );

  return APIHandler.handleResponse(response);
}